module.exports = __webpack_public_path__ + "img/fondo-gris-abstracto_29865-2379.06a1db18.webp";